var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';
import "../../themes/alert.js";
import { borderRadiusLarge } from "../../themes/borders.js";
import "../../themes/button.js";
import "../../themes/checkbox.js";
import "../../themes/divider.js";
import "../../themes/dropdown.js";
import "../../themes/fieldset.js";
import "../../themes/input.js";
import "../../themes/list.js";
import "../../themes/listbox.js";
import "../../themes/loader.js";
import "../../themes/option.js";
import "../../themes/popout.js";
import "../../themes/switch.js";
import "../../themes/themes.js";
import "../../themes/tooltip.js";
var baseListStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", "px;\n  border-color: transparent;\n  border-style: solid;\n  display: block;\n  list-style: none;\n  margin: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  z-index: 1;\n"])), borderRadiusLarge);
/**
 * Get Styled Component virtualized CSS styles
 * @param options GetListVirtualizedCssOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getListVirtualizedCss = function getListVirtualizedCss(options) {
  var borderWidth = options.borderWidth,
    height = options.height,
    padding = options.padding;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border-width: ", "px;\n    max-height: ", "px;\n    padding: ", "px;\n  "])), borderWidth, height, padding);
};
/**
 * Get Styled Component list theme
 * @param options GetListThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getListTheme = function getListTheme(options) {
  var look = options.look;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.list[look].backgroundColor;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.list[look].borderColor;
  });
};
export { baseListStyle, getListTheme, getListVirtualizedCss };